import { Grid } from '@radix-ui/themes';
import { EB } from 'components/layout/error-boundary';
import { RadixGridColumn } from 'enums/radix';
import { ReactNode } from 'react';

export const CommonFormGrid = (props: {
  columns: RadixGridColumn;
  children: ReactNode;
}) => (
  <EB>
    <form>
      <Grid gap="2" columns={props.columns} mb="4">
        {props.children}
      </Grid>
    </form>
  </EB>
);
